import React from "react";
import { useTranslation } from "react-i18next";

function ShortsSdkVersion() {
  const { t } = useTranslation();
  return (
    <div className="version">
      <p>
        {t("label-version")} v{"6.0.0.0"}
      </p>
    </div>
  );
}

export default ShortsSdkVersion;
